import { ASIDE_PANEL_LOCALSTORAGE, IAsidePanelLocalStorage } from '../types';

export const setAsidePanelLocalStorage = (
    asidePanel: IAsidePanelLocalStorage
) => {
    localStorage.setItem(ASIDE_PANEL_LOCALSTORAGE, JSON.stringify(asidePanel))
};
